<form [formGroup]="selectedStaffList" data-testid="staff-selector-form">
  <p-multiSelect
    [options]="nestedArray"
    [group]="true"
    formControlName="selectedStaffs"
    [placeholder]="placeholder() | translate"
    styleClass="w-full text-sm"
    display="chip"
    [filter]="true"
    filterBy="label"
    [autofocusFilter]="true"
    [virtualScroll]="nestedArray.length > 0"
    [virtualScrollItemSize]="virtualScrollItemSize"
    scrollHeight="280px"
    appendTo="body"
    [loading]="loading()"
    (onChange)="getSelectedStaff($event)"
    data-testid="staff-multiselect"
    aria-label="staff-multiselect"
  >
    <ng-template let-group pTemplate="group">
      <div class="flex align-items-center" data-testid="staff-group">
        <span
          data-testid="staff-group-label"
          [attr.data-testid]="'staff-group-label-' + group.id"
          >{{ group.label }}</span
        >
      </div>
    </ng-template>
    <ng-template let-option pTemplate="item">
      <div
        class="flex align-items-center"
        [style.height.px]="virtualScrollItemSize"
        [attr.data-testid]="'staff-option-' + option.id"
      >
        <span [attr.data-testid]="'staff-option-name-' + option.id">{{
          option.label
        }}</span>
      </div>
    </ng-template>
  </p-multiSelect>
</form>
